import RetrieveCardInputTemplate from "../../../templates/admin/retrieveCardInput";

const RetrieveCardInputScreen = () => {
  return <RetrieveCardInputTemplate />;
};

export default RetrieveCardInputScreen;
